import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "sort",
    standalone: false
})
export class ArraySortPipe  implements PipeTransform {
	transform(array: any[]): any[] {
		array.sort((a: any, b: any) => {
			if (a < b) {
				return -1;
			} else if (a > b) {
				return 1;
			} else {
				return 0;
			}
		});
		return array;
	}
}